// constants
import { FILTER_KEYS } from '../RosterPlan.consts';

// types
import type {
  RosterPlanFilterSelection,
  RosterPlanFiltersForm
} from '../RosterPlan.types';

// utils
import { normalizeToOptionArray } from './rosterPlanFilterOptions';

/**
 * The filter form's values as the grids want them: one entry per group that actually has a
 * selection, in `FILTER_KEYS` order.
 *
 * Groups the planner left untouched are dropped rather than carried as empty arrays, because
 * `applyRosterPlanFilters` treats every entry it receives as a constraint.
 */
export const toAppliedFilters = (
  values: RosterPlanFiltersForm
): RosterPlanFilterSelection[] =>
  FILTER_KEYS.map((key) => ({
    key,
    value: normalizeToOptionArray(values[key])
  })).filter((selection) => selection.value.length > 0);
